export const ADMIN_PUBKEY="nFFYWRxDJECCK9Q6fHuFShyQmFFF3mpgjMPiP9m8bYX"

export const ROLL_DECIMALS = 9;
export const MONOPOLY_DECIMALS = 6;

// local
/*
export const CLUSTER_URL="http://127.0.0.1:8899"
export const WS_CLUSTER_URL=undefined
export const MONOPOLY_MINT="Hain2Pueg2vx5KTGrj75ZviYi22dpAq7C17wXBgonAjb"
export const ROLL_MINT="Ge9q1fQo66mT3jBveFnNntba4nn7cNttdM1cKYYD5mS9"
*/

// devnet
/*
export const CLUSTER_URL="https://api.devnet.solana.com"
export const WS_CLUSTER_URL=undefined
export const MONOPOLY_MINT="42k62tW6UmrkbzA8qnbK8z8NBq3bearxCghSgMi7M9ww"
export const ROLL_MINT="5BDNees68DUEcykrRpA7DpmrL4RknLFSPK6F7yrDqVd9"
*/

// prod
//export const CLUSTER_URL="https://solana-mainnet.g.alchemy.com/v2/-avZgvjrLpayTTV9tWZGbVe2iTbUM_KM"
export const CLUSTER_URL="https://snowy-special-log.solana-mainnet.quiknode.pro/"
export const WS_CLUSTER_URL="wss://snowy-special-log.solana-mainnet.quiknode.pro/"
export const MONOPOLY_MINT="DC8SPXFu6gRibfmY4dhD4JL9e3eaEDPMCPcEDpQ9XskP"
export const ROLL_MINT="CB7wU3MCYktMP2WmTwD7iTWJHPrW4FaAMqKW4HnLATm1"
